import { reactive } from "vue";

const state = reactive({ loadingCount: 0, mounted: false });

export default { state };
